import { useState, useEffect, useCallback, useRef } from 'react'

let globalLoaded = false

function loadScript(onLoad) {
  const script = document.createElement('script')
  script.type = 'module'
  script.src =
    'https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.esm.js'
  script.onload = onLoad
  document.head.appendChild(script)
}

function loadCss(onLoad) {
  const stylesheet = document.createElement('link')
  stylesheet.rel = 'stylesheet'
  stylesheet.href =
    'https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.css'
  stylesheet.onload = onLoad
  document.head.appendChild(stylesheet)
}

export function useZapier() {
  const [loaded, setLoaded] = useState(globalLoaded)
  const scriptLoaded = useRef(globalLoaded)
  const cssLoaded = useRef(globalLoaded)

  const handleScriptLoad = useCallback(() => {
    scriptLoaded.current = true
    if (cssLoaded.current) {
      setLoaded(true)
    }
  }, [])

  const handleCssLoad = useCallback(() => {
    cssLoaded.current = true
    if (scriptLoaded.current) {
      setLoaded(true)
    }
  }, [])

  useEffect(
    () => {
      if (loaded) {
        globalLoaded = true
      }
    },
    [loaded]
  )

  useEffect(() => {
    if (!globalLoaded) {
      loadScript(handleScriptLoad)
      loadCss(handleCssLoad)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    loaded,
  }
}
